const publicAuthPaths = new Set([
  "/login",
  "/logout",
  "/register",
  "/password-reset",
  "/password-reset-form",
]);

const publicPaths = new Set([...publicAuthPaths, "/theme", "/about"]);

export function isPublicAuthPath(pathname: string): boolean {
  return publicAuthPaths.has(pathname.replace(/\/+$/, "") || "/");
}

export function isPublicPath(pathname: string): boolean {
  return publicPaths.has(pathname.replace(/\/+$/, "") || "/");
}

export function localRedirect(value?: string): string {
  return value?.startsWith("/") &&
    !value.startsWith("//") &&
    !value.includes("\\") &&
    Array.from(value).every((character) => {
      const code = character.charCodeAt(0);
      return code > 0x20 && code !== 0x7f;
    })
    ? value
    : "/";
}
